import { Spinner } from '@tallink/components-lib'
import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getSummary } from '../../../selectors/selectors'
import useFormatPrice from '../../../utils/formatPrice'
import s from './TotalPrice.module.scss'

export default function TotalPrice() {
  const { t } = useTranslation()
  const formatPrice = useFormatPrice()
  const { price, regularPrice, loading } = useSelector(getSummary)
  const withRegularPrice = regularPrice > 0 && regularPrice !== price

  return (
    <div className={s['total-price']}>
      {loading && (
        <div className={s['spinner-container']}>
          <Spinner className={s.spinner} />
        </div>
      )}
      <div className={classNames(s.content, { [s.hidden]: loading })}>
        <div className={s.text}>{t('price.total')}</div>
        <div className={s.price}>
          {formatPrice(price)}
          {withRegularPrice && (
            <div className={s['regular-price']}>
              {t('price.regular')} {formatPrice(regularPrice)}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
